import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';
import { CALL_API } from '../../middleware/api';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

const SUBMIT_TEMP_FILE_REQUEST = 'SUBMIT_TEMP_FILE_REQUEST';
const SUBMIT_TEMP_FILE_SUCCESS = 'SUBMIT_TEMP_FILE_SUCCESS';
const SUBMIT_TEMP_FILE_FAILURE = 'SUBMIT_TEMP_FILE_FAILURE';

export const changePassword = (payload) => {
  return {
    [CALL_API]: {
      types: [CHANGE_PASSWORD_REQUEST, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE],
      authenticated: true,
      endpoint: 'Account/ChangeUserPassword',
      method: 'POST',
      payload,
    },
  };
};

export const submitChangePasswordRequest = (emailAddress) => {
  return {
    [CALL_API]: {
      types: [CHANGE_PASSWORD_REQUEST, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE],
      authenticated: true,
      endpoint: 'Client/SubmitChangePasswordRequest/submitchangepassword',
      method: 'POST',
      headers: {
        'Authorization': `Basic ${process.env.REACT_APP_BASIC_AUTH_KEY}`,
      },
      emailAddress,
    },
  };
    
}

export const submitTempFile = (tempFileId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [SUBMIT_TEMP_FILE_REQUEST, SUBMIT_TEMP_FILE_SUCCESS, SUBMIT_TEMP_FILE_FAILURE],
      authenticated: true,
      endpoint: `api/tempFiles/submitAuth?tempFileId=${tempFileId}`,
      method: 'POST'
    },
  };
};
